import React from 'react';
import { Box, Button, Typography, Container, useTheme, alpha } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useThemeContext } from '../context/ThemeContext';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { mode } = useThemeContext();
  const isDark = mode === 'dark';

  return (
    <Box 
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        py: 5,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            backgroundColor: theme.palette.background.paper,
            boxShadow: isDark 
              ? '0 8px 32px rgba(0, 0, 0, 0.2)' 
              : '0 8px 32px rgba(37, 99, 235, 0.1)',
            border: isDark 
              ? `1px solid ${alpha(theme.palette.primary.main, 0.1)}` 
              : `1px solid ${alpha(theme.palette.primary.main, 0.05)}`,
          }}
        >
          <ErrorOutlineIcon 
            sx={{ 
              fontSize: 100, 
              color: theme.palette.error.main,
              mb: 2,
              opacity: 0.8
            }} 
          />
          
          <Typography 
            variant="h1" 
            sx={{ 
              fontSize: { xs: '4rem', md: '6rem' },
              fontWeight: 700,
              color: theme.palette.primary.main,
              mb: 2,
            }}
          >
            404
          </Typography>
          
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 2,
              fontWeight: 600 
            }}
          >
            Page Not Found
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              mb: 4,
              maxWidth: 500,
              color: theme.palette.text.secondary
            }}
          >
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate('/')}
            sx={{ 
              py: 1.5, 
              px: 4, 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              boxShadow: `0 8px 16px ${alpha(theme.palette.primary.main, 0.2)}`,
              '&:hover': {
                boxShadow: `0 12px 20px ${alpha(theme.palette.primary.main, 0.3)}`,
              },
            }}
          >
            Back to Dashboard
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;